/* tslint:disable */
/* eslint-disable */
export enum SystemSettingType {
  Text = 1,
  SecureText = 2,
  Password = 3,
  Email = 4,
  Telephone = 5,
  Url = 6,
  Color = 7,
  PlainText = 11,
  RichText = 12,
  HTML = 13,
  Markdown = 14,
  Date = 15,
  Time = 16,
  Datetime = 17,
  Number = 21,
  PercentageInteger = 22,
  Decimal = 25,
  Currency = 26,
  PercentageDecimal = 27,
  OneOption = 31,
  MultipleOptions = 32,
  CheckBox = 35,
  Bytes = 41,
  Image = 42,
  File = 43,
  Video = 44,
  Audio = 45,
  Photo = 101,
  User = 102,
  Form = 103,
  UserLoginPolicy = 104,
  PayPeriodFrequency = 105,
  ServiceSetting = 106,
  StaffingCancellationReason = 107,
  TicketType = 108,
  TicketStatus = 109,
  TicketPriority = 110,
  PatientDocumentCategory = 111,
  InsuranceCode = 112,
  InsuranceProvider = 113,
  UserRole = 114,
  Training = 115,
  Credential = 116,
  LiablePerson = 117
}
